.keyValueInputContainer {
  display: flex;
  padding-top: 12px;
  row-gap: 12px;
  flex-direction: column;
}

.keyValueInputItem {
  position: relative;
  display: flex;
  column-gap: 6px;
  align-items: center;
  max-width: 600px;

  > :nth-child(1),
  input {
    max-height: 40px;
    max-width: 300px;
  }

  &.boolean {
    row-gap: 24px;
    max-width: unset;
    justify-content: space-between;
    .objectRowSeparator {
      display: none;
    }
  }

  .keyValueBooleanSelect {
    min-width: 106px;
  }

  &.error {
    input {
      @include themify($themes) {
        border-color: themed("error-primary") !important;
      }
    }
  }
}

.addRowButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  border-radius: 12px;
  height: 40px;
  cursor: pointer;
  transition: background-color 0.25s ease-out, border-color 0.25s ease-out;
  user-select: none;

  @include themify($themes) {
    border: 1px solid themed("neutral-secondary");
  }

  &:hover {
    transition: background-color 0.25s ease-in, border-color 0.25s ease-in;
    @include themify($themes) {
      background-color: themed("neutral-primary");
    }
  }
}

.removeRowButtonContainer {
  display: flex;
  align-items: center;
  justify-content: center;
}

.removeRowButton {
  display: flex;
  height: 16px;
  width: 16px;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  font-weight: bold;
  cursor: pointer;
  user-select: none;
  
  @include themify($themes) {
    background-color: themed("error-primary");
  }
}

.valueContainer {
  position: relative;
}

.keyContainer {
  width: 100%;
  position: relative;
}
